import Constants from '../Constants';

const { TOGGLE_MODAL, SET_MODAL_DATA } = Constants;

export const toggleModal = (endpoint, method) => async (dispatch) => {
    dispatch({type: TOGGLE_MODAL, payload: { endpoint, method } });
}

export const setModalData = ( endpoint, method, data ) => async (dispatch) => {
    dispatch({type: SET_MODAL_DATA, payload: { endpoint, method, data } });
}






// WEBPACK FOOTER //
// ./src/Actions/ModalActions.js